<div>
  <div class="d-flex w-100">
    <div class="d-block w-100 position-relative chart-container">
      <div
        #pahighchart
        (mousemove)="onChartMouseMove($event)"
        (click)="onChartClick($event)"
        (mouseleave)="schedulePopupHide()"
      >
        @if (hChartOptions) {
          <highcharts-chart
            [Highcharts]="highcharts"
            [options]="hChartOptions"
            [callbackFunction]="chartCallback"
            class="w-100 d-block"
          ></highcharts-chart>
        }
      </div>
    </div>
  </div>

  @if (showAlarmPopup === true) {
    <div
      #alarmPopup
      class="position-fixed over-map"
      [style.top.px]="popupTop"
      [style.left.px]="popupLeft"
      (mouseenter)="cancelPopupHide()"
      (mouseleave)="schedulePopupHide()"
    >
      <div class="card custom-shadow">
        <div class="card-body p-0">
          <app-performance-alarm-list
            [alarms]="popupAlarms"
            [timezone]="timezone"
            [popupVersion]="popupVersion"
            [expandOnOpen]="popupPinned"
            (clicked)="onPopupClicked()"
            (closed)="hidePopup()"
          ></app-performance-alarm-list>
        </div>
      </div>
    </div>
  }
</div>
